import { h, render } from 'preact';

const find = (selector, element = document) => [].slice.call(element.querySelectorAll(selector));

const multiTimeout = (times = []) => (fn) => {
    times.forEach(time => {
        setTimeout(fn, time);
    });
};

const getTop = elem => {
    const box = elem.getBoundingClientRect();

    const body = document.body;
    const docEl = document.documentElement;

    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

    const clientTop = docEl.clientTop || body.clientTop || 0;

    const top = box.top + scrollTop - clientTop;

    return Math.round(top);
};

const getOuterHeight = elem => {
    const style = elem.currentStyle || window.getComputedStyle(elem);
    const margin = Number(style.marginBottom.match(/^\d+/g, '').join(''));
    return (elem.clientHeight || elem.offsetHeight) + margin;
};

const createStickyWrapper = () => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('stickyMobileNavigationWrapper');
    return wrapper;
};

const StickyMobileNavigation = ({ links, button, visible }) =>
  <div className={['stickyMobileNavigation', visible && 'stickyMobileNavigation--active'].filter(x=>x).join(' ')}>
    {links.map(link =>
      <div className={`stickyMobileNavigation__icon stickyMobileNavigation__icon--${link.getAttribute('data-icon')}`}>
        <a href={link.getAttribute('href')}>
          <img src={link.getAttribute('data-iconuri')} />
        </a>
      </div>)
    }
    <a className="stickyMobileNavigation__button" href={button.getAttribute('href')}>
      {button.innerText} <i className="fa fa-angle-double-right"/>
    </a>
  </div>
;

export default el => {
  const linkContainer = el.querySelector('.linkContainer');
  let savedTop = getTop(el);
  if (matchMedia('(min-width: 700px)').matches) {
    // Desktop Sticky Navigation
    const height = getOuterHeight(linkContainer);

    const placeholder = document.createElement('div');
    placeholder.style.height = '0';
    el.parentNode.insertBefore(placeholder, el);

    const onScroll = () => {
      const posTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (posTop <= savedTop) {
        placeholder.style.height = 0;
        el.classList.remove('stickyNavigation--sticky');
      } else {
        placeholder.style.height = `${height}px`;
        el.classList.add('stickyNavigation--sticky');
      }
    };

    document.addEventListener('scroll', onScroll);
    onScroll();

    multiTimeout([0,200,400])(() => {
      el.classList.remove('stickyNavigation--sticky');
      savedTop = getTop(el);
      onScroll();
    });
  } else {
    // Mobile Sticky Navigation
    const links = find('.link', linkContainer);
    const button = linkContainer.querySelector('.btn');

    const wrapper = createStickyWrapper();
    document.body.appendChild(wrapper);

    let root;
    const renderStickyNavMobile = visible => {
      root = render(
        <StickyMobileNavigation
          links={links}
          button={button}
          visible={visible}
        />,
        wrapper,
        root
      );
    };
    renderStickyNavMobile();

    const onScroll = () => {
      const posTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (posTop <= savedTop) {
        renderStickyNavMobile(false);
      } else {
        renderStickyNavMobile(true);
      }
    };

    document.addEventListener('scroll', onScroll);
    onScroll();

    document.querySelector('.bottombar').style.display = 'none';

    multiTimeout([0, 200, 400])(() => {
      savedTop = getTop(el);
      onScroll();
      const chatContainer = document.querySelector('#tawkchat-container');
      if (chatContainer) {
        chatContainer.parentNode.removeChild(chatContainer);
      }
    });
  }
}
